import React, { FC } from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { LocalesLanguagesConstants } from '../../../locales/locales';
import { LinkResponseDto } from '../../../store/landscapeAPI/link/dto/response/link-response.dto';
import { PromiseSettledResult } from '../../../utils/types/types';
import { Button, Label } from '../../atoms';
import {
  LandscapeIndicatorExternalResourceForm,
  TranslationOrganism,
} from '../../organisms';
import BaseTemplate from '../BaseTemplate';

import styles from './LandscapeIndicatorExternalResourceAddTemplate.module.css';

export interface LandscapeIndicatorExternalResourceAddTemplateProps {
  externalResource: LinkResponseDto;
  handleExternalResourceChange: (externalResource: LinkResponseDto) => void;
  handleAddExternalResource: (externalResource: LinkResponseDto) => void;
  setLanguage: React.Dispatch<React.SetStateAction<LocalesLanguagesConstants>>;
  selectedLanguage: LocalesLanguagesConstants;
  fromLanguage: LocalesLanguagesConstants;
  setFromLanguage: React.Dispatch<
    React.SetStateAction<LocalesLanguagesConstants>
  >;
  toLanguage: LocalesLanguagesConstants;
  setToLanguage: React.Dispatch<
    React.SetStateAction<LocalesLanguagesConstants>
  >;
  generateTranslation: () => Promise<void>;
  generateAllTranslations: () => Promise<PromiseSettledResult<void>[]>;
}

const LandscapeIndicatorExternalResourceAddTemplate: FC<
  LandscapeIndicatorExternalResourceAddTemplateProps
> = ({
  externalResource,
  handleExternalResourceChange,
  handleAddExternalResource,
  setLanguage,
  selectedLanguage,
  fromLanguage,
  setFromLanguage,
  toLanguage,
  setToLanguage,
  generateTranslation,
  generateAllTranslations,
}) => {
  const { id, landscapeIndicatorId } = useParams();
  const navigate = useNavigate();

  return (
    <BaseTemplate>
      <Container>
        <div className={styles.heading}>
          <Label
            content="Create External Resource
"
            size="lg"
          />
          <Button
            className={styles.buttonLink}
            variant="link"
            onClick={() =>
              navigate(
                `/landscapes/edit/${id}/indicators/edit/${landscapeIndicatorId}/external-resources`
              )
            }
          >
            Back to Landscape Indicator detail
          </Button>
        </div>
        <TranslationOrganism
          setLanguage={setLanguage}
          selectedLanguage={selectedLanguage}
          fromLanguage={fromLanguage}
          setFromLanguage={setFromLanguage}
          toLanguage={toLanguage}
          setToLanguage={setToLanguage}
          generateTranslation={generateTranslation}
          generateAllTranslations={generateAllTranslations}
        />
        <LandscapeIndicatorExternalResourceForm
          externalResource={externalResource}
          handleExternalResourceChange={handleExternalResourceChange}
          handleSubmitExternalResource={handleAddExternalResource}
        />
      </Container>
    </BaseTemplate>
  );
};

export default LandscapeIndicatorExternalResourceAddTemplate;
